import React from 'react'
import useStyles from '../../styles'

export const Footer = () => {
  const classes = useStyles()
  return (
    <div className={classes.footer}>
      <div className="priv">
        <p>Privacidade</p>
        <p>Aviso Comercial</p>
      </div>
      <div>v2.8.3 © 2022 Cargill, Incorporated. Todos os direitos reservados.</div>
    </div>
  )
}
